import { Injectable } from "@angular/core";
import { MapperInterface } from "@app/shared/mapper/mapper-inteface";
import { StrutturaFascicoloVO } from "../vo/struttura-fascicoloVO";
import { StrutturaFascicoloDTO } from "../dto/struttura-fascicoloDTO";

@Injectable({
  providedIn: "root",
})
export class MapperStrutturaFascicolo
  implements MapperInterface<StrutturaFascicoloDTO, StrutturaFascicoloVO> {
  convertVoToDto(e: StrutturaFascicoloVO): StrutturaFascicoloDTO {
    const strutturaDTO = new StrutturaFascicoloDTO();
    if (e !== null && e !== undefined) {
    strutturaDTO.cmu = e.cmu;
    strutturaDTO.nome = e.nome;
    }
    return strutturaDTO || new StrutturaFascicoloDTO();
  }
  convertDtoToVo(t: StrutturaFascicoloDTO): StrutturaFascicoloVO {
    const strutturaVO = new StrutturaFascicoloVO();
    if (t !== null && t !== undefined) {
      strutturaVO.cmu = t.cmu;
      strutturaVO.nome = t.nome;
    }
    return strutturaVO || new StrutturaFascicoloVO();
  }
  convertListVoToDto(e: StrutturaFascicoloVO[]): StrutturaFascicoloDTO[] {
    const strutturaDTOList = new Array<StrutturaFascicoloDTO>();
    if (e != null && e.length > 0) {
      e.forEach((strutturaVO) => {
        strutturaDTOList.push(this.convertVoToDto(strutturaVO));
      });
    }
    return strutturaDTOList || new Array<StrutturaFascicoloDTO>();
  }

  convertListDtoToVo(t: StrutturaFascicoloDTO[]): StrutturaFascicoloVO[] {
    // console.log("[MapperStruttura] StrutturaDTOList => StrutturaVOList");
    const strutturaVOList = new Array<StrutturaFascicoloVO>();
    if (t != null && t.length > 0) {
      t.forEach((strutturaDTO) => {
        strutturaVOList.push(this.convertDtoToVo(strutturaDTO));
      });
    }
    return strutturaVOList || new Array<StrutturaFascicoloVO>();
  }
}
